import { render } from "./VideoWindow.vue?vue&type=template&id=15df13e8&scoped=true"
import script from "./VideoWindow.vue?vue&type=script&lang=js"
export * from "./VideoWindow.vue?vue&type=script&lang=js"

import "./VideoWindow.vue?vue&type=style&index=0&id=15df13e8&lang=css"
import "./VideoWindow.vue?vue&type=style&index=1&id=15df13e8&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15df13e8"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
